const STORAGE_KEY = 'allorep_cookie_consent_v1';
const EXPIRY_DAYS = 395;
const EVENT_NAME = 'allorep:consent-change';

export const CONSENT_CATEGORIES = {
  necessary: { id: 'necessary', label: 'Strictement nécessaires', required: true },
  analytics: { id: 'analytics', label: 'Mesure d’audience', required: false },
  preferences: { id: 'preferences', label: 'Personnalisation', required: false },
};

const defaultConsent = () => ({
  necessary: true,
  analytics: false,
  preferences: false,
});

const isExpired = (timestamp) => {
  if (!timestamp) return true;
  return Date.now() - timestamp > EXPIRY_DAYS * 24 * 60 * 60 * 1000;
};

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (isExpired(parsed.timestamp)) return null;
    return parsed;
  } catch (err) {
    console.error('Error reading consent from localStorage:', err);
    return null;
  }
};

export const setConsent = (values) => {
  const payload = {
    ...defaultConsent(),
    ...values,
    necessary: true,
    timestamp: Date.now(),
    version: 1,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (err) {
    console.error('Error saving consent to localStorage:', err);
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: payload }));
  }
  return payload;
};

export const acceptAll = () => setConsent({ analytics: true, preferences: true });
export const rejectAll = () => setConsent({ analytics: false, preferences: false });
export const clearConsent = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.error('Error clearing consent from localStorage:', err);
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: null }));
  }
};

export const onConsentChange = (handler) => {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
};

export const CONSENT_EVENT = EVENT_NAME;
